<template>
    <div>
        <Row class="card-charts">
            <i-col class="chart-item"
                   span="6">
                <div class="chart-content"
                     @click="gotoMonitor">
                    <div id="chartContent"
                         :style="`height: ${rgHeight}`"
                         class="chart-content-rcGauge">
                        <rcGauge ref="rcGaugeC"
                                 :rgHeight="rgHeight"
                                 :value="monitorData.cpuUsedRate"
                                 :hideName="true"
                                 :name="$t('CPU') + $t('使用率')" />
                    </div>
                    <p class="chart-content-title">{{$t('CPU') + $t('使用率')}}</p>
                </div>
            </i-col>
            <!--华为公有云暂不支持内存使用率 -->
            <i-col class="chart-item"
                   span="6">
                <div class="chart-content"
                     @click="gotoMonitor">
                    <div :style="`height: ${rgHeight}`"
                         class="chart-content-rcGauge">
                        <rcGauge ref="rcGaugeM"
                                 :rgHeight="rgHeight"
                                 :hideName="true"
                                 :value="monitorData.memoryUsedRate"
                                 :name="$t('内存') + $t('使用率')" />
                    </div>
                    <p class="chart-content-title">{{$t('内存') + $t('使用率')}}</p>
                </div>
            </i-col>
            <!-- 磁盘读存速度 -->
            <i-col class="chart-item"
                   :span="6">
                <div class="chart-content height-142 card-pro">
                    <div @click="gotoMonitor"
                         class="pro-container pad-top0">
                        <p>读取</p>
                        <rcProgress class="margin"
                                    :value="monitorData.diskRead.value"
                                    :height="monitorData.diskRead.height" />
                        <p style="color: #333;">{{monitorData.diskRead.value}}</p>
                    </div>
                    <div @click="gotoMonitor"
                         class="pro-container pad-top0">
                        <p>写入</p>
                        <rcProgress class="margin"
                                    :value="monitorData.diskWrite.value"
                                    :height="monitorData.diskWrite.height" />
                        <p style="color: #333;">{{monitorData.diskWrite.value}}</p>
                    </div>
                </div>
                <p class="tip">{{$t('磁盘速度')}}({{monitorData.diskWrite.unit || '--' }})</p>
            </i-col>
            <!-- 网络速度 -->
            <i-col class="chart-item"
                   :span="6">
                <div class="chart-content height-142 card-pro">
                    <div @click="gotoMonitor"
                         class="pro-container pad-top0">
                        <p style="white-space: nowrap;">{{$t('入流量')}}</p>
                        <rcProgress class="margin"
                                    :value="monitorData.netIn.value"
                                    :height="monitorData.netIn.height" />
                        <p style="color: #333;">{{monitorData.netIn.value}}</p>
                    </div>
                    <div @click="gotoMonitor"
                         class="pro-container pad-top0">
                        <p style="white-space: nowrap;">{{$t('出流量')}}</p>
                        <rcProgress class="margin"
                                    :value="monitorData.netOut.value"
                                    :height="monitorData.netOut.height" />
                        <p style="color: #333;">{{monitorData.netOut.value}}</p>
                    </div>
                </div>
                <p class="tip">{{$t('网络流量')}}({{monitorData.netOut.unit || '--' }})</p>
            </i-col>
        </Row>
    </div>
</template>

<script>
import API from '@/service/api'
import rcGauge from '../rcGauge'
import rcProgress from '../rcProgress'
export default {
    name: 'monitordetail',
    props: ['data'],
    components: {
        rcGauge,
        rcProgress
    },
    data () {
        return {
            monitorData: {
                cpuUsedRate: -1,
                memoryUsedRate: -1,
                diskRead: {
                    value: 0,
                    height: 0,
                    unit: ''
                },
                diskWrite: {
                    value: 0,
                    height: 0,
                    unit: ''
                },
                netIn: {
                    value: 0,
                    height: 0,
                    unit: ''
                },
                netOut: {
                    value: 0,
                    height: 0,
                    unit: ''
                }
            },
            rgHeight: '160px'
        }
    },
    created () {
        this.getThumbnailMonitorInfo()
    },
    mounted () {
        const width = document.getElementById('chartContent').offsetWidth
        this.rgHeight = (width * 125 / 140) + 'px'
    },
    methods: {
        gotoMonitor () {
            this.$emit('goto')
        },
        async getThumbnailMonitorInfo () {
            if (this.data.serverType !== 'server') {
                this.axios.get(this.urlFormat(API.GET_MONITOR_DATA_LATEST + '/' + this.$route.params.id, true)).then(res => {
                    this.anasMonitorData(res)
                })
            }
        },
        // 解析监控数据
        anasMonitorData (data) {
            (data.metricDatas || []).forEach(item => {
                if (item.metric === 'cpu_usage') {
                    this.monitorData.cpuUsedRate = item.metricTimeValues.length === 0 ? 0 : item.metricTimeValues[0].value ? parseFloat(item.metricTimeValues[0].value) : 0
                } else if (item.metric === 'mem_memused_percent') {
                    this.monitorData.memoryUsedRate = item.metricTimeValues.length === 0 ? 0 : item.metricTimeValues[0].value ? parseFloat(item.metricTimeValues[0].value) : 0
                } else if (item.metric === 'disk_io_msec_read') {
                    this.monitorData.diskRead.value = item.metricTimeValues.length === 0 ? 0 : item.metricTimeValues[0].value ? parseFloat(item.metricTimeValues[0].value) : 0
                    this.monitorData.diskRead.unit = item.unit
                } else if (item.metric === 'disk_io_msec_write') {
                    this.monitorData.diskWrite.value = item.metricTimeValues.length === 0 ? 0 : item.metricTimeValues[0].value ? parseFloat(item.metricTimeValues[0].value) : 0
                    this.monitorData.diskWrite.unit = item.unit
                } else if (item.metric === 'net_if_in_bytes') {
                    this.monitorData.netIn.value = item.metricTimeValues.length === 0 ? 0 : item.metricTimeValues[0].value ? parseFloat(item.metricTimeValues[0].value) : 0
                    this.monitorData.netIn.unit = item.unit
                } else if (item.metric === 'net_if_out_bytes') {
                    this.monitorData.netOut.value = item.metricTimeValues.length === 0 ? 0 : item.metricTimeValues[0].value ? parseFloat(item.metricTimeValues[0].value) : 0
                    this.monitorData.netOut.unit = item.unit
                }
            })

            // 动态判断柱状体高度
            const diskHeight = this.computeHeight(this.monitorData.diskRead.value, this.monitorData.diskWrite.value)
            this.monitorData.diskRead.height = diskHeight[0]
            this.monitorData.diskWrite.height = diskHeight[1]
            const netHeight = this.computeHeight(this.monitorData.netIn.value, this.monitorData.netOut.value)
            this.monitorData.netIn.height = netHeight[0]
            this.monitorData.netOut.height = netHeight[1]
            // 仪表盘初始化
            this.$refs.rcGaugeC.resize()
        },
        computeHeight (val1, val2) {
            var rate = Math.random()
            const data = [0, 0]
            const mod = parseFloat(val1) > parseFloat(val2)
            if (mod) {
                data[0] = (92 * rate)
                data[1] = (70 * rate)
            } else {
                data[0] = (70 * rate)
                data[1] = (92 * rate)
            }
            if (parseFloat(val1) === 0) {
                data[0] = 0
            }
            if (parseFloat(val2) === 0) {
                data[1] = 0
            }
            return data
        }
    }
}
</script>
<style lang="less" scoped>
.card-charts {
    height: 190px;
    padding: 0px 15px;
    .chart-item {
        padding: 0px 15px;
        .chart-content {
            height: 160px;
            position: relative;
            .chart-content-rcGauge {
                max-height: 160px;
            }
            .chart-content-title {
                position: absolute;
                bottom: 0px;
                text-align: center;
                width: 100%;
                font-size: 12px;
            }
        }
        .height-142 {
            height: 142px;
        }
        .tip {
            text-align: center;
            font-size: 12px;
            color: #333;
        }
    }
    .chart-item:hover {
        box-shadow: 0px 0px 10px 10px #f5f6f7;
    }
    .card-pro {
        display: flex;
        justify-content: center;
        color: #ccc;
        .pro-container {
            margin: 0px 15px;
            padding-top: 25px;
            text-align: center;
            .margin {
                margin: 0 auto;
            }
            p {
                margin: 5px 0px;
                line-height: 16px;
            }
        }
    }
    .no-tips {
        height: 190px;
        text-align: center;
        line-height: 190px;
        font-size: 16px;
        color: #ccc;
    }
}
</style>
